import DistributorsService from '../../services/distributors.service.js';
import i18n from '../../i18n.js';

export const state = {
  distributorData: null
};

export const mutations = {
  SET_DISRIBUTOR(state, profile) {
    state.distributorData = profile;
  }
};

export const actions = {
  async getDistributorDate({ commit, dispatch }) {
    try {
      const { distributorId } = this.state.profile.profileData;
      if (!distributorId) {
        return null;
      }
      const { data: distributorData } = await DistributorsService.getDistributorDate(distributorId);
      commit('SET_DISRIBUTOR', distributorData);
      commit('SET_SUBSCRIPTION', {
        expirationDate: distributorData.brokerBalance.expirationDate,
        total: distributorData.brokerBalance.amount,
        type: distributorData.subscriptions?.users ? 'Users' : 'Credits'
      });
      await dispatch('getPlan');

      return distributorData;
    } catch (err) {
      console.error(err);
    }
  },
  async updateDistributor({ commit, state, dispatch }, data) {
    const { body, notification } = data;
    try {
      const updateDistributorData = await DistributorsService.updateDistributor(
        state.distributorData.id,
        body
      );
      commit('SET_DISRIBUTOR', {
        ...state.distributorData,
        updateDistributorData
      });
      await dispatch('getDistributorDate');
      dispatch('addNotification', notification);
      return updateDistributorData;
    } catch (err) {
      const errorNotification = {
        type: 'error',
        message: i18n.t(`feedback.errors.changeLogo`),
        fieldToEdit: notification.fieldToEdit,
        show: notification.show
      };
      dispatch('addNotification', errorNotification);
      console.error(err);
      console.error(errorNotification.message);
    }
  },
  async updateDistributorLogo({ state, dispatch }, data) {
    const { body, notification } = data;
    try {
      const updateDistributorLogo = await DistributorsService.updateDistributorLogo(
        state.distributorData.id,
        body
      );
      await dispatch('getDistributorDate');
      dispatch('addNotification', notification);
      return updateDistributorLogo;
    } catch (err) {
      const errorNotification = {
        type: 'error',
        message: `feedback.errors.changeLogo`,
        show: notification.show
      };
      dispatch('addNotification', errorNotification);
      console.error(err);
    }
  },
  async purchaseCredits({ dispatch }, data) {
    const { creditsData, notification } = data;
    try {
      const purchaseCredits = await DistributorsService.purchaseCredits(
        state.distributorData.id,
        creditsData
      );
      dispatch('addNotification', notification);
      await dispatch('getDistributorDate');
      return purchaseCredits;
    } catch (error) {
      console.error(error);
    }
  }
};
